module.exports = __webpack_public_path__ + "static/media/portfolio1 (4).a859dfe3.jpeg";